import React, { forwardRef, createRef, useImperativeHandle } from 'react';
import { F as FormField } from './FormField-BneBLurL.js';

function InputNumberInternal(props, ref) {
    var _a;
    const inputRef = createRef();
    useImperativeHandle(ref, () => ({
        blur: () => {
            const input = inputRef.current;
            if (input) {
                input.blur();
            }
        },
        focus: () => {
            const input = inputRef.current;
            if (input) {
                input.focus();
            }
        },
    }));
    return (React.createElement(FormField, Object.assign({}, props, { type: "number", inputRef: inputRef, onChange: handleChange, validations: Object.assign(Object.assign({}, props.validations), { validate: customValidators((_a = props.validations) === null || _a === void 0 ? void 0 : _a.validate) }) })));
    function customValidators(validators) {
        if (validators == null) {
            return getOverLimitMessage;
        }
        else if (typeof validators === "function") {
            return {
                customValidation: validators,
                getOverLimitMessage,
            };
        }
        return Object.assign(Object.assign({}, validators), { getOverLimitMessage });
    }
    function handleChange(newValue) {
        props.onChange && props.onChange(newValue);
    }
    function getOverLimitMessage(value) {
        const isOverMax = props.max != undefined && value && value > props.max;
        const isUnderMin = props.min != undefined && value && value < props.min;
        if (isOverMax || isUnderMin || (value && value.toString() === "")) {
            if (props.min != undefined && props.max === undefined) {
                return `Enter a number that is greater than or equal to ${props.min}`;
            }
            else if (props.max != undefined && props.min === undefined) {
                return `Enter a number that is less than or equal to ${props.max}`;
            }
            else if (props.min != undefined && props.max != undefined) {
                return `Enter a number between ${props.min} and ${props.max}`;
            }
        }
        return true;
    }
}
const InputNumber = forwardRef(InputNumberInternal);

export { InputNumber as I };
